/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      console.log( 'spacing' );
      // find any sections with a data-component="hero-grid"
      // of those sections, see if the next sibling section has a data-component="alt-treatments" or data-component="what-it-treats", but it has to be the next section
      // if it does, remove the padding-top from the alt-treatments or what-it-treats section
      const heroGridSections = $( '[data-component="hero-grid"]' );
      heroGridSections.each( function() {
        const nextSection = $( this ).next();

        if ( nextSection.length > 0 ) {
          const nextSectionComponent = nextSection.attr( 'data-component' );
          if ( nextSectionComponent === 'alt-treatments' || nextSectionComponent === 'what-it-treats' ) {
            nextSection.css( 'padding-top', '0' );
          }
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'spacing', COMPONENT );
} )( app );
